<template>
  <div>
    <div class="mrB20" />
    <div class="comm_view_wrap">
      <div class="row">
        <div class="col-xs-1 ">
          <sui-input-label
            :label="$t('MSG_TXT_MAIL_STRBX_NM')"
            :required="true"
          />
        </div>
        <div class="col-xs-5 ">
          <cmp-mlng-editor
            ref="mlngEditor"
            :pageId="contextPageId"
            :editable="true"
            :multiLanguageId="objMailStorageBox.mailStorageBoxMultiLanguageId"
          />
        </div>
        <div class="col-xs-1 ">
          <sui-input-label
            :label="$t('MSG_TXT_MAIL_STRBX_ID')"
            :required="true"
          />
        </div>
        <div class="col-xs-5 ">
          <div class="comm_label">
            MBX_
          </div>
          <div class="comp_spacing" />
          <sui-text-field
            ref="textFieldMAILStorageBoxId"
            v-model="mailStorageBoxIdPostfix"
            maxlength="100"
            :disabled="!isNew"
            @keyup="onKeyUpInput(mailStorageBoxIdPostfix)"
          />
          <div class="comp_spacing" />
          <sui-button
            type="button"
            class="comm_btn_duplicate"
            :disabled="!isNew"
            @click="onClickCheckDuplication"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-xs-1 ">
          <sui-input-label
            :label="$t('MSG_TXT_KEYWORD')"
            :required="true"
          />
        </div>
        <div class="col-xs-5 ">
          <sui-text-field
            ref="textFieldKEYWORD"
            v-model="objMailStorageBox.mailStorageBoxKeywordValue"
            maxlength="100"
          />
        </div>
        <div class="col-xs-1 ">
          <sui-input-label
            :label="$t('MSG_TXT_MAIL_MVNT_YN')"
            :required="true"
          />
        </div>
        <div class="col-xs-5 ">
          <sui-radio
            v-model="objMailStorageBox.mailMovementYn"
            value="Y"
          >
            {{ 'Yes' }}
          </sui-radio>
          <sui-radio
            v-model="objMailStorageBox.mailMovementYn"
            value="N"
          >
            {{ 'No' }}
          </sui-radio>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-1 ">
          <sui-input-label
            :label="$t('MSG_TXT_PRTH_INCL_YN')"
            :required="true"
          />
        </div>
        <div class="col-xs-5 ">
          <sui-radio
            v-model="objMailStorageBox.prthInclusionYn"
            value="Y"
          >
            {{ 'Yes' }}
          </sui-radio>
          <sui-radio
            v-model="objMailStorageBox.prthInclusionYn"
            value="N"
          >
            {{ 'No' }}
          </sui-radio>
        </div>
        <div class="col-xs-1 ">
          <sui-input-label
            :label="$t('MSG_TXT_PAGE_ID')"
            :required="true"
          />
        </div>
        <div class="col-xs-5 ">
          <sui-text-field
            ref="textFieldPageId"
            v-model="objMailStorageBox.pageId"
            :readonly="true"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-xs-1">
          <sui-input-label
            :label="$t('MSG_TXT_RGST_USR')"
          />
        </div>
        <div class="col-xs-5">
          <cmp-user-name-link
            :pageId="contextPageId"
            :displayType="'1'"
            :displayLanguageId="objMailStorageBox.firstRegistrationDisplayLangId"
            :loginId="objMailStorageBox.firstRegistrationLoginId"
            :knoxId="objMailStorageBox.firstRegistrationKnoxId"
            :userName="objMailStorageBox.firstRegistrationUserName"
            :userGlobalName="objMailStorageBox.firstRegistrationUserGlobalName"
            :departmentName="objMailStorageBox.firstRegistrationDepartmentName"
            :departmentEnglishName="objMailStorageBox.firstRegistrationDepartmentEnglishName"
            type="link"
          />
        </div>
        <div class="col-xs-1">
          <sui-input-label
            :label="$t('MSG_TXT_RGST_DTM')"
          />
        </div>
        <div class="col-xs-5">
          <div class="comm_label">
            {{ objMailStorageBox.firstRegistrationDTM }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-1">
          <sui-input-label
            :label="$t('MSG_TXT_MDFC_USR')"
          />
        </div>
        <div class="col-xs-5">
          <cmp-user-name-link
            :pageId="contextPageId"
            :displayType="'1'"
            :displayLanguageId="objMailStorageBox.finalModificationDisplayLangId"
            :loginId="objMailStorageBox.finalModificationLoginId"
            :knoxId="objMailStorageBox.finalModificationKnoxId"
            :userName="objMailStorageBox.finalModificationUserName"
            :userGlobalName="objMailStorageBox.finalModificationUserGlobalName"
            :departmentName="objMailStorageBox.finalModificationDepartmentName"
            :departmentEnglishName="objMailStorageBox.finalModificationDepartmentEnglishName"
            type="link"
          />
        </div>
        <div class="col-xs-1">
          <sui-input-label
            :label="$t('MSG_TXT_MDFC_DTM')"
          />
        </div>
        <div class="col-xs-5">
          <div class="comm_label">
            {{ objMailStorageBox.finalModificationDTM }}
          </div>
        </div>
      </div>
    </div>
    <div class="mrB30" />
    <div class="comm_btn_wrap">
      <sui-button
        v-permission:create="contextPageId"
        type="button"
        class="comm_btn_border"
        @click="onClickMenuRegist()"
      >
        {{ $t('MSG_BTN_MENU_RGST') }}
      </sui-button>
      <sui-button
        type="button"
        class="comm_btn_border"
        @click="onClickNew"
      >
        {{ $t("MSG_BTN_NEW") }}
      </sui-button>
      <sui-button
        v-permission:delete="contextPageId"
        type="button"
        class="comm_btn_border"
        @click="onClickDelete"
      >
        {{ $t("MSG_BTN_DEL") }}
      </sui-button>
      <sui-button
        v-permission:create="contextPageId"
        type="button"
        class="comm_btn_solid"
        @click="onClickSave"
      >
        {{ $t("MSG_BTN_SAVE") }}
      </sui-button>
    </div>
  </div>
</template>

<script>
import BasePage from '~cm/components/BasePage';

export default {
  name: 'PGE_CMM_00008_T01', // eslint-disable-line vue/name-property-casing
  extends: BasePage,
  props: {
    selectedGridRowData: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      isNew: true,
      isCheckDuplication: false,
      mailStorageBoxIdPostfix: '',
      objMailStorageBox: {
        mailStorageBoxId: '',
        mailStorageBoxName: '',
        mailStorageBoxKeywordValue: '',
        mailMovementYn: 'N',
        prthInclusionYn: 'N',
        pageId: '',
        mailStorageBoxMultiLanguageId: '',
        firstRegistrationDTM: '',
        finalModificationDTM: '',
        // 등록자 정보
        firstRegistrationLoginId: '',
        firstRegistrationKnoxId: '',
        firstRegistrationUserName: '',
        firstRegistrationUserGlobalName: '',
        firstRegistrationDepartmentName: '',
        firstRegistrationDepartmentEnglishName: '',
        firstRegistrationDisplayLangId: '',
        // 수정자 정보
        finalModificationLoginId: '',
        finalModificationKnoxId: '',
        finalModificationUserName: '',
        finalModificationUserGlobalName: '',
        finalModificationDepartmentName: '',
        finalModificationDepartmentEnglishName: '',
        finalModificationDisplayLangId: '',
      },
    };
  },
  computed: {},
  watch: {
    selectedGridRowData(selectObj) {
      if (!utils.isEmpty(selectObj)) {
        this.loadMailStorageBox();
        this.isNew = false;
      } else {
        this.isNew = true;
      }
    },
    mailStorageBoxIdPostfix(data) {
      if (this.objMailStorageBox.mailStorageBoxIdPostfix !== data) {
        this.isCheckDuplication = false;
      }
    },
  },
  created() {
    this.customOptions = {
    };
  },
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    loadMailStorageBox() {
      if (this.selectedGridRowData) {
        const mailStorageBoxId = this.selectedGridRowData.mailStorageBoxId;
        if (!utils.isEmpty(mailStorageBoxId)) {
          http.request(this.contextPageId, 'DTS_CMM_00010', {
            path: {
              'mailstorage-box-id': mailStorageBoxId,
            },
          }).then(res => {
            this.objMailStorageBox = res.data;
            this.objMailStorageBox.firstRegistrationDTM = utils.dateformatToClient(this.objMailStorageBox.firstRegistrationDTM);
            this.objMailStorageBox.finalModificationDTM = utils.dateformatToClient(this.objMailStorageBox.finalModificationDTM);

            this.isNew = false;
            this.mailStorageBoxIdPostfix = this.objMailStorageBox.mailStorageBoxId.substring(4);
          });
        }
      }
    },
    onClickNew() {
      utils.forEach(this.objMailStorageBox, (value, key) => {
        this.objMailStorageBox[key] = '';
      });
      this.objMailStorageBox.mailMovementYn = 'N';
      this.objMailStorageBox.prthInclusionYn = 'N';

      this.isNew = true;
      this.isCheckDuplication = false;
      this.mailStorageBoxIdPostfix = '';
      this.$refs.mlngEditor.reset();
      this.$emit('clearGridSelection');
    },
    onClickDelete() {
      const mailStorageBoxId = this.objMailStorageBox.mailStorageBoxId;
      if (!utils.isEmpty(mailStorageBoxId)) {
        utils.messageBox('confirm', this.$t('MSG_ALT_WANT_DEL'), null, () => {
          http.request(this.contextPageId, 'DTS_CMM_00013', {
            path: {
              'mailstorage-box-id': mailStorageBoxId,
            },
          }).then(() => {
            utils.messageBox('success', this.$t('MSG_ALT_DELETED'), null, this.research);
          });
        });
      } else {
        utils.messageBox('warning', this.$t('MSG_ALT_NOT_SEL_ITEM'));
      }
    },
    onClickSave() {
      if (!this.validateData()) {
        return;
      }
      utils.messageBox('confirm', this.$t('MSG_ALT_WANT_SAVE'), null, () => {
        this.objMailStorageBox.mailStorageBoxId = this.isNew ? `MBX_${this.mailStorageBoxIdPostfix}` : this.objMailStorageBox.mailStorageBoxId;
        this.objMailStorageBox.mailStorageBoxMultiLanguageId = `MSG_TIT_MBX_${this.objMailStorageBox.mailStorageBoxId}`;
        this.objMailStorageBox.multiLanguageList = this.$refs.mlngEditor.getMlngEditingInfoFillEmptyWithGlobal();
        this.objMailStorageBox.mailStorageBoxName = this.$refs.mlngEditor.$refs.localTxtFld.value;

        const dataServiceId = this.isNew ? 'DTS_CMM_00011' : 'DTS_CMM_00012';
        http.request(this.contextPageId, dataServiceId, {
          data: this.objMailStorageBox,
        }).then(() => {
          utils.messageBox('success', this.$t('MSG_ALT_SAVE_DATA'), null, this.research);
        });
      });
    },
    validateData() {
      if (utils.isEmpty(utils.trim(this.$refs.mlngEditor.$refs.localTxtFld.value))) {
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_INPUT_CELL'), this.$t('MSG_TXT_LOCAL_LNG')),
          null, () => {
            this.$refs.mlngEditor.setFocusLocalTxtFld();
          });
        return false;
      }
      if (utils.isEmpty(utils.trim(this.$refs.mlngEditor.$refs.globalTxtFld.value))) {
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_INPUT_CELL'), this.$t('MSG_TXT_GLOBAL_LNG')),
          null, () => {
            this.$refs.mlngEditor.setFocusGlobalTxtFld();
          });
        return false;
      }
      if (this.isNew && utils.isEmpty(this.mailStorageBoxIdPostfix)) {
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_NCSR'), this.$t('MSG_TXT_MAIL_STRBX_ID')), null, () => {
          this.$refs.textFieldMAILStorageBoxId.setFocus();
        });
        return false;
      }
      if (this.isNew && !this.isCheckDuplication) {
        utils.messageBox('error', this.$t('MSG_ALT_CHK_DUP'), null);
        return false;
      }
      if (utils.isEmpty(this.objMailStorageBox.mailStorageBoxKeywordValue)) {
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_NCSR'), this.$t('MSG_TXT_KEYWORD')), null, () => {
          this.$refs.textFieldKEYWORD.setFocus();
        });
        return false;
      }
      if (utils.isEmpty(this.objMailStorageBox.mailMovementYn)) {
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_NCSR'), this.$t('MSG_TXT_MAIL_MVNT_YN')), null, () => {
          this.$refs.textFieldMAILMVNTYn.setFocus();
        });
        return false;
      }
      if (utils.isEmpty(this.objMailStorageBox.prthInclusionYn)) {
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_NCSR'), this.$t('MSG_TXT_PRTH_INCL_YN')), null, () => {
          this.$refs.textFieldPRTHInclusionYn.setFocus();
        });
        return false;
      }
      return true;
    },
    onClickCheckDuplication() {
      if (!utils.isEmpty(this.mailStorageBoxIdPostfix)) {
        http.request(this.contextPageId, 'DTS_CMM_00014', {
          query: {
            'mailstorage-box-id': `MBX_${this.mailStorageBoxIdPostfix}`,
          },
        }).then(res => {
          if (res.data.resultCode === '0') {
            utils.messageBox('error', utils.strFormat(this.$t('MSG_ALT_DUPLICATE_EXISTS')));
          } else {
            utils.messageBox('success', utils.strFormat(this.$t('MSG_ALT_BE_RGST_OK'), this.$t('MSG_TXT_MAIL_STRBX_ID')));
            this.isCheckDuplication = true;
          }
        });
      } else {
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_NCSR'), this.$t('MSG_TXT_MAIL_STRBX_ID')), null, () => {
          this.$refs.textFieldMAILStorageBoxId.setFocus();
        });
      }
    },
    research() {
      this.onClickNew();
      this.$emit('research');
    },
    onKeyUpInput(value) {
      if (utils.isExistSpecialChar(value)) {
        utils.messageBox('warning', this.$t('MSG_ALT_CHK_SPECL_CHAR'), null, () => {
          this.mailStorageBoxIdPostfix = this.mailStorageBoxIdPostfix.replace(
            /[^A-Za-z0-9_.]/g, '',
          );
        });
      }
    },
    onClickMenuRegist() {
      if (utils.isEmpty(this.selectedGridRowData)) {
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_SELECT'), this.$t('MSG_TXT_MAIL_STRBX')));
        return false;
      }
      this.$emit('openMenuPopup', this.selectedGridRowData.pageId);
      return true;
    },
  },
};
</script>

<style scoped>
</style>
